export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8702.d6602d9c.jpg";